import Vue from 'vue';
import Router from 'vue-router';

// Route components
import Login from '@login/Components/Login';
import RecoverUser from '@login/Components/RecoverUser';
import PasswordReset from '@login/Components/PasswordReset';
import PasswordResetStart from '@login/Components/PasswordResetStart';
import PasswordResetSecurity from '@login/Components/PasswordResetSecurity';
import PasswordResetNew from '@login/Components/PasswordResetNew';
import PasswordResetComplete from '@login/Components/PasswordResetComplete';
import Terms from '@shared/components/TermsConditions';
import ErrorPage from '@shared/components/ErrorPage';
import DataPrivacy from '@shared/components/DataPrivacy';
import CookiePolicy from '@shared/components/CookiePolicy';

Vue.use(Router);

export default new Router({
    routes: [
        {
            name: 'default',
            path: '*',
            redirect: {
                name: 'Login',
            },
        },
        {
            path: '/',
            name: 'Login',
            component: Login,
        },
        {
            name: 'passwordreset',
            path: '/passwordreset',
            component: PasswordReset,
            redirect: {
                name: 'passwordreset.username',
            },
            children: [
                {
                    name: 'passwordreset.username',
                    path: '/username',
                    component: PasswordResetStart,
                },
                {
                    name: 'passwordreset.security',
                    path: '/security',
                    component: PasswordResetSecurity,
                },
                {
                    name: 'passwordreset.new',
                    path: '/new',
                    component: PasswordResetNew,
                },
                {
                    name: 'passwordreset.complete',
                    path: '/complete',
                    component: PasswordResetComplete,
                },
            ],
        },
        {
            name: 'recoveruser',
            path: '/recoveruser',
            component: RecoverUser,
        },
        {
            name: 'terms',
            path: '/terms',
            component: Terms,
        },
        {
            name: 'error',
            path: '/error/:code',
            component: ErrorPage,
        },
        {
            name: 'dataprivacy',
            path: '/data-privacy',
            component: DataPrivacy,
        },
        {
            name: 'cookiepolicy',
            path: '/cookie-policy',
            component: CookiePolicy,
        },
    ],
});



// WEBPACK FOOTER //
// ./login/router/index.js